module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-avatar-maker-green-05318da8.svg";